import { Component, OnInit, Input, Output, EventEmitter, Directive } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MarcaModel } from '../../Modelo/Marca.model';

@Component({
    selector: 'lista-sort',
    templateUrl: './lista-sort.component.html',
    styles: []
})
export class ListaSortComponent implements OnInit {

    @Input() Nombre: string = "";
    @Input() Placeholder: string = "";
    @Input() OrigenDeDatos: any[] = [];
	@Input() ValorMostrado: string = "";
	@Input() ValorSeleccionado: any[] = [];
    @Input() disabled: boolean = false;
	@Output() ValorSeleccionadoChange: EventEmitter<any[]> = new EventEmitter();

    public TextoABuscar: string = "";

    constructor() { }

    ngOnInit(): void {
    }

    public Seleccionar(item: any): void {
        this.ValorSeleccionado = item;
        this.ValorSeleccionadoChange.emit(this.ValorSeleccionado);
	}
}